import { Vue, Component, Prop, px } from '@/utils';

@Component({
  name: 'v-image',
})
export class Image extends Vue {
  @Prop({required: true}) public src: string;
  @Prop({default: false}) public block: boolean;
  @Prop({default: false}) public contain: boolean;
  @Prop({default: 'center center'}) public position: string;
  @Prop({default: 'no-repeat'}) public repeat: string;
  @Prop({default: 40, type: [Number, String]}) public size: any;
  @Prop({type: [Number, String]}) public width: any;
  @Prop({type: [Number, String]}) public height: any;

  get imageStyles() {
    const styles: any = {
      'background-image': `url(${this.src})`,
      'background-size': this.contain ? 'contain' : 'cover',
      'background-position': this.position,
      'background-repeat': this.repeat,
      'display': this.block ? 'block' : 'inline-block',
    };
    if (this.width || this.size) {
      styles.width = this.width == null ? px(this.size) : px(this.width);
    }
    if (this.height || this.size) {
      styles.height = this.height == null ? px(this.size) : px(this.height);
    }
    return styles;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/image.ts